import React, { forwardRef } from 'react';
import { object, array, string } from 'prop-types';

import Exhibitions from '../Exhibitions/Exhibitions';

import './ArchiveExhibitionsList.scss';

const ArchiveExhibitionsList = forwardRef(
  ({ archiveExhibitions, staticText, language }, ref) => {
    if (!archiveExhibitions.length) return null;

    return (
      <div className="archive-exhibitions-list" ref={ref}>
        <h1 className="archive-exhibitions-list__title">
          {staticText.sidebarArchive}
        </h1>
        <div>
          {archiveExhibitions.map((exhibition) => (
            <Exhibitions
              key={exhibition.id}
              name={exhibition.name}
              title={exhibition.title}
              dateFrom={exhibition.dateFrom}
              dateTo={exhibition.dateTo}
              description={exhibition.description}
              subHeader={exhibition.subHeader}
              descriptionBlock2={exhibition.descriptionBlock2}
              subDescription={exhibition.subDescription}
              listOfPeople={exhibition.listOfPeople}
              pictures={exhibition.pictures}
              pdfFiles={exhibition.pdfFiles}
              links={exhibition.link}
              galleryFiles={exhibition.galleryFiles}
              staticText={staticText}
              language={language}
              isExpandable
            />
          ))}
        </div>
      </div>
    );
  },
);

ArchiveExhibitionsList.propTypes = {
  archiveExhibitions: array,
  staticText: object,
  language: string,
};

ArchiveExhibitionsList.defaultProps = {
  archiveExhibitions: [],
  staticText: {},
  language: '',
};

export default ArchiveExhibitionsList;
